<template>
  <div class="canvas-wrapper"></div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import anime from 'animejs';
import WebglApp from '@/scripts/stage/WebglApp';

export default {
  name: 'Webgl',
  data() {
    return {
      orb: null,
      IS_SPECULAR_MODE: true,
      IS_LIGHT_ROTATING: false,
    };
  },
  computed: {
    ...mapState([
      'pageIndex',
      'menuIsOpen',
    ]),
    isInHome() {
      return this.$route.name === 'Home';
    },
    baseDepth() {
      if (this.menuIsOpen) return 18;
      if (this.isInHome) {
        if (this.pageIndex === 1) return 28;
        if (this.pageIndex === 2) return 35;
        return 18;
      }
      if (this.pageIndex === 1) return 22;
      if (this.pageIndex === 2) return 30;
      return 14;
    },
    baseMorph() {
      if (this.menuIsOpen) return 0;
      if (this.pageIndex === 1) return 0.60;
      if (this.pageIndex === 2) return 1;
      return 0.30;
    },
    baseFogFar() {
      if (this.menuIsOpen) return 26;
      if (this.isInHome) {
        if (this.pageIndex === 1) return 36;
        if (this.pageIndex === 2) return 45;
        return 26;
      }
      if (this.pageIndex === 1) return 25;
      if (this.pageIndex === 2) return 35;
      return 15;
    },
    baseFogNear() {
      if (this.menuIsOpen) return 10;
      if (this.isInHome) {
        if (this.pageIndex === 1) return 20;
        if (this.pageIndex === 2) return 30;
        return 10;
      }
      if (this.pageIndex === 1) return 5;
      if (this.pageIndex === 2) return 5;
      return 5;
    },
  },
  watch: {
    pageIndex() {
      this.blobMorphAnimation();
    },
    isInHome(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.blobMorphAnimation();
      }
    },
    menuIsOpen() {
      this.blobMorphAnimation();
    },
  },
  methods: {
    ...mapMutations([
      'stopLoadingResources',
      'toggleBlobTransition',
    ]),
    blobAppearAnimation() {
      return anime({
        targets: this.orb,
        offsetY: 0,
        depth: 20,
        duration: 5000,
        easing: 'easeOutCubic',
        complete: () => {
          this.stopLoadingResources();
          this.$eventHub.$emit('resourcesIsLoaded');
        },
      });
    },

    blobMorphAnimation() {
      anime.remove(this.orb);
      this.toggleBlobTransition(true);

      return anime({
        targets: this.orb,
        morph: this.baseMorph,
        fogFar: this.baseFogFar,
        fogNear: this.baseFogNear,
        depth: this.baseDepth,
        offsetY: this.isInHome || this.menuIsOpen ? 0 : window.innerHeight / 2,
        duration: 4000,
        easing: 'easeInOutCubic',
        complete: () => {
          this.toggleBlobTransition(false);
        },
      });
    },
  },
  created() {
    this.$eventHub.$once('morph', this.blobMorphAnimation);
  },
  mounted() {
    this.orb = new WebglApp({
      container: document.querySelector('.canvas-wrapper'),
      isSpecularLighting: this.IS_SPECULAR_MODE,
      isLightRotating: this.IS_LIGHT_ROTATING,
    });

    this.orb.load()
      .then(() => {
        // start the orb
        this.orb.start();

        // add RESIZE event listeners
        window.addEventListener('resize', () => {
          this.orb.resize(window.innerWidth, window.innerHeight);
        });

        // set default props
        this.orb.depth = 45;
        this.orb.scale = 1;
        // app.depth = 20;
        this.orb.organicity = 0.0;
        this.orb.morph = 0;
        this.orb.shapeA = 3;
        this.orb.shapeN = 2;
        this.orb.shapeM = 1;
        this.orb.offsetY = -600;
        this.orb.fogNear = 10;
        this.orb.fogFar = 26;
        this.orb.fogColor = 0xE4C0C4;
        // this.orb.fogColor = 0xeaf2f5;
        this.orb.layerPower = 0.0;
        this.orb.objColor = 0xc2acb2;
        this.orb.hemi_ground = 0xdbdbdb;
        this.orb.hemi_color_1 = 0x96d3e1;
        this.orb.hemi_color_2 = 0xf7d9aa;
        this.orb.hemi_color_3 = 0xe096c3;
        this.orb.rota_x = 0;
        this.orb.rota_y = 0.3;
        this.orb.rota_z = 0;

        if (this.IS_SPECULAR_MODE) {
          this.orb.shininess = 5;
          this.orb.specularity = 4;
          this.orb.specpower = 1;
        }

        this.$nextTick(() => {
          this.orb.play();
          this.blobAppearAnimation();
        });
      });
  },
};
</script>

<style scoped lang="scss">
.canvas-wrapper {
  position: fixed;
  top: 0;
  left: 0;
}
</style>
